var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-input-container",
    [
      _c("label", { attrs: { for: "network" } }, [_vm._v("Age")]),
      _c(
        "md-select",
        {
          attrs: { name: "age", multiple: _vm.multiple },
          on: { selected: _vm.onSelected },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        _vm._l(_vm.ages, function(age) {
          return _c("md-option", { key: age.key, attrs: { value: age.key } }, [
            _vm._v(_vm._s(age.value))
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-314d27da", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314d27da","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/demographic/AgeSelector.vue
// module id = 938
// module chunks = 0